module.exports = __webpack_public_path__ + "static/img/4areaA_3.d812ffe.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント_イラスト/4areaA_3.png
// module id = 901
// module chunks = 1